import script from "./EstablishmentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./EstablishmentItem.vue?vue&type=script&setup=true&lang=js"

import "./EstablishmentItem.vue?vue&type=style&index=0&id=4b247fca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b247fca"]])

export default __exports__